
enum CheckEditReason {
    CHECK_DATE_OR_TIME = 0,
    CHECK_LOCATION_IN_CABINET,
    CHECK_LOCATION_IN_HOUSE,
    WORKER_INFO,
    INJURY_INFO
}

export default CheckEditReason;